/* Contact Form — file list display */
(function() {
  var input = document.getElementById('ContactFiles');
  if (!input) return;
  var list = document.querySelector('[data-file-list]');
  if (!list) return;
  input.addEventListener('change', function() {
    var files = Array.from(input.files);
    list.textContent = files.length ? files.map(function(f) { return f.name; }).join(', ') : '';
  });
})();
